export default "__VITE_ASSET__PnNuLMQJ__"